module.exports = __webpack_public_path__ + "static/media/glove1.40c96eb6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/bonus/glove/glove1.jpg
// module id = 52
// module chunks = 0